import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { submitWaitlist } from '../../services/waitlistService';

const WaitlistPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const utm = useMemo(() => {
    try {
      return window.location.search || '';
    } catch {
      return '';
    }
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    if (!consent) {
      setError('Please accept the consent to join the waitlist.');
      return;
    }

    setLoading(true);
    try {
      await submitWaitlist({
        email,
        consent: true,
        sourcePath: window.location.pathname,
        utm,
        createdAt: new Date().toISOString(),
      });
      setSuccess('You\'re on the waitlist! We\'ll notify you at this email.');
      setEmail('');
      setConsent(false);
      navigate('/');
    } catch (err: any) {
      const msg = err?.response?.data?.message || 'Something went wrong. Please try again later.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="section-dark">
      <div className="container" style={{ maxWidth: 560 }}>
        <h2 className="section-title text-center" style={{ marginTop: 24 }}>Join the Waitlist</h2>
        <p className="text-center" style={{ marginBottom: 24 }}>
          Be the first to access our research outreach program when it launches.
        </p>

        {success && (
          <div className="alert alert-success" role="alert">
            {success}
          </div>
        )}
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={onSubmit} className="card p-4" style={{ background: '#0f0f0f', borderColor: '#333' }}>
          <div className="mb-3">
            <label htmlFor="waitlistEmail" className="form-label">Email address</label>
            <input
              id="waitlistEmail"
              type="email"
              className="form-control"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="consentCheck"
              checked={consent}
              onChange={(e) => setConsent(e.target.checked)}
              required
            />
            <label className="form-check-label" htmlFor="consentCheck">
              I agree to receive emails about product updates and accept the Privacy Policy.
            </label>
          </div>

          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? 'Joining...' : 'Join Waitlist'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default WaitlistPage;
